import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Button, Col, FlexboxGrid, Form, Schema } from 'rsuite'
import { useRouter } from 'next/router'

import useIsOnMobile from '../../services/useIsOnMobile'
import { ScreenSize } from '../../utils/constants'
import EmailInput from '../Input/EmailInput'

import styles from '../../styles/LandingPage/Newsletter.module.less'
import customFormStyles from '../../styles/CustomForm.module.less'

// Rsuite Form validation
const { StringType } = Schema.Types

const Newsletter: FC = () => {
  const { t } = useTranslation('common')
  const { locale } = useRouter()

  const emailModel = Schema.Model({
    email: StringType()
      .isRequired(t('auth:This field is required'))
      .isEmail(t('auth:Please enter a valid email')),
  })

  const isOnMobile = useIsOnMobile(ScreenSize.md)

  return (
    // NOTE: Adding locale as key in order to display form when
    // a user submit the form and change language
    <div
      key={locale}
      className={styles.newsletter}
    >
      <div>
        <FlexboxGrid justify="center">
          <FlexboxGrid.Item
            as={Col}
            sm={20}
            xs={24}
          >
            <div
              data-testid="newsletter-banner-heading"
              className="h2"
            >
              {t('Join the newsletter list of Europes leading wholesale buyers')}
            </div>
            <p className={styles.text}>
              {t('Be the first to hear about offers, industry trends and get tips on industrial supplies')}
            </p>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <div
          id="63f5e88bb89e337867d3b637-form"
          className="63f5e88bb89e337867d3b637-template"
        >
          <div
            id="selected-_wl9x2jy0v"
            className=" ap3w-embeddable-form-63f5e88bb89e337867d3b637 ap3w-embeddable-form-63f5e88bb89e337867d3b637-full ap3w-embeddable-form-63f5e88bb89e337867d3b637-solid "
            data-select="true"
          >
            <Form
              model={emailModel}
              id="ap3w-embeddable-form-63f5e88bb89e337867d3b637"
              className={`ap3w-embeddable-form-content  ${customFormStyles['custom-form']}`}
            >
              <FlexboxGrid
                id="selected-_8rwfu2zb8"
                className="ap3w-form-input ap3w-form-input-63f5e88bb89e337867d3b637"
                data-select="true"
                data-field-id="str::email"
                data-merge-strategy="override"
                justify="center"
              >
                <FlexboxGrid.Item
                  as={Col}
                  sm={20}
                  xs={24}
                >
                  <FlexboxGrid
                    justify="center"
                    className={styles['form-elements']}
                  >
                    <FlexboxGrid.Item className="flex-grow-1">
                      <Form.Group>
                        <EmailInput
                          type="email"
                          id="ap3w-form-input-email-63f5e88bb89e337867d3b637"
                          step="1"
                          name="email"
                          placeholder={t('modals:companyEmail')}
                          autoComplete="email"
                        />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item
                      id="selected-_9gqjjnnkt"
                      className=" ap3w-form-button ap3w-form-button-63f5e88bb89e337867d3b637 "
                    >
                      <Button
                        id="ap3w-form-button-63f5e88bb89e337867d3b637"
                        type="submit"
                        data-select="true"
                        data-button-on-click="thank-you"
                        appearance="primary"
                        size="lg"
                        className={isOnMobile ? 'margin-top-spacer' : 'margin-left-spacer-double'}
                        block
                      >
                        {t('Join now')}
                      </Button>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </div>
        </div>
        {/* NOTE: The following confirmation code will be copied by ortto code logic */}
        {/* once the form is submitted. Also it will be hidden to avoid duplication */}
        <div className={styles['success-message-container']}>
          <div
            id="63f5e88bb89e337867d3b637-thank-you"
            className="63f5e88bb89e337867d3b637-template"
          >
            <div
              id="selected-_lbvdt6v58"
              className=" ap3w-embeddable-form-63f5e88bb89e337867d3b637 ap3w-embeddable-form-63f5e88bb89e337867d3b637-full ap3w-embeddable-form-63f5e88bb89e337867d3b637-solid "
              data-select="true"
            >
              <form
                id="ap3w-embeddable-form-63f5e88bb89e337867d3b637"
                className="ap3w-embeddable-form-content"
              >
                <div className="ap3-form-br" />
                <div
                  id="selected-_n9454gbkn"
                  className="ap3w-text ap3w-text-63f5e88bb89e337867d3b637 ap3w-text--first ap3w-text--last"
                >
                  <div data-select="true">
                    <div className="h3">
                      {t("Thank you, you're added to the list")}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Newsletter
